module.exports = __webpack_public_path__ + "static/media/atom_big.c9ac9d5b.png";